export default function idGenerator() {
    return Math.floor(Math.random() * 100000)
}



// WEBPACK FOOTER //
// ./src/idGenerator.js